import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css'
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter className="pagina">
    <App />
  </BrowserRouter>
);

reportWebVitals();
